import React from 'react'
import styled from 'styled-components'

const Error = () => {
  return (
    <Wrapper>
        <div className="section section-center text-center">
        <h2 className="text-white display-3"><span className="font-weight-bold">Aconteceu um erro no carregamento das publicações.</span> <br />Por favor, tente mais tarde.</h2>
        </div>
    </Wrapper>  
  )
}

const Wrapper = styled.section` 
      margin-top: 8rem;
      min-height: 75vh;
      
`

export default Error